// extracted by mini-css-extract-plugin
export default {"ModalHeader":"fAcnu21Z5i5n9vLUMBZt","ModalBody":"Hsiozik72h9S8MbRMR4a","Buttons":"texyqaZHhbYNESMeL1JM"};